<template>
    <el-container>
        <!--<el-header class="clearfix" height="48px">
            <div class="logo-box">
                <div><a href='javascript:;' style="padding-top: 13px;box-sizing: border-box;"><img src="@/assets/img/logo.png"></a></div>
            </div>
        </el-header>-->
        <div class="login-page">
            <div class="login-content">
                <div class="login-box flex-block">
                    <div class="login-left">
                        <img src="@/assets/img/pic_chahua.png" alt="背景图片" class="bg-img"  style="border-radius: 10px;width: 80%;">
                        <!--<div class="bg-text">C味消费 一键消费</div>-->
                    </div>
                    <div class="login-right">
                        <div class="login-logo">
                            <img src="@/assets/img/logo.png" alt="logo图片" class="logo-img"  style="width: 38%;height: 120px;border-radius: 50%;">
                        </div>
                        <!-- <h1>后台系统</h1> -->
                        <el-form :model="form" :rules="rules" id="main-content">
                            <el-form-item prop="username" class="form-group">
                                <el-input class="full_all" v-model="form.username" clearable placeholder="输入用户名"></el-input>
                            </el-form-item>
                            <el-form-item prop="password" class="form-group">
                                <el-input class="full_all" placeholder="输入密码" clearable v-model="form.password" show-password></el-input>
                            </el-form-item>
                          <!--  <el-form-item prop="captcha" class="form-group">
                                <el-input class="txm_input" v-model="form.captcha" clearable placeholder="输入图形验证码"></el-input>
                                <span class="img-box"><img class="captcha" style="border-radius:4px;" :src="captchaSrc" @click="getCaptcha()"/></span>
                            </el-form-item> -->
                            <el-row class="m-b-5">
                               <!-- <el-col :span="12">
                                    <el-checkbox v-model="remember">记住密码</el-checkbox>
                                </el-col> -->
                                <!--<el-col :span="12">
                                    <router-link to="/retrieve" class="link-box" style="text-align: right;margin-top: 4px;">忘记密码？</router-link>
                                </el-col>-->
                                <el-col :span="12" style="text-align: right;">
                                    <!--<router-link to="/retrieve" class="link-box" style="text-align: right;margin-top: 4px;">忘记密码？</router-link>-->
                                    <!--<el-button type="text" @click="">忘记密码？</el-button>-->
                                </el-col>
                            </el-row>
                            <el-form-item style="margin-bottom: 0;margin-top: 10px;">
                                <el-button type="primary" :loading="form.loading" class="submit_btn f-16" @click="submitLogin">登录</el-button>
                            </el-form-item>
                            <!--<router-link to="/register" class="link-box">注册新账号 <i class="el-icon-right"></i></router-link>-->
                        </el-form>

                    </div>
                </div>
            </div>
        </div>
    </el-container>
    
</template>
<script>
   import {JSEncrypt} from "jsencrypt"
    export default {
        name: '',
        data() {
            return {
                // captchaSrc:this.$client.API_URL+"/adminapi/account/captcha",
                form:{
                    username:'',
                    password:"",
                    captcha:"",
                    loading: false,
                },
                remember:false,
                rules:{
                    username:{required: true, message: '输入用户名', trigger: ['change','blur']},
                    password:[
                        {required: true, message: '请输入密码', trigger: ['change','blur']},
                        { min: 6, max: 30,  message: '密码至少输入6位',trigger: 'blur'}],
                    captcha:{required: true, message: '请输入图形验证码', trigger: ['change','blur']},
                }
            }
        },
        created() {
            document.title = '登录';
            this.getStorage();
            var _this = this;
            //回车登录
            document.onkeydown = function(e) {
                var key = window.event.keyCode;
                if (_this.$route.path =='/login' && key == 13) {
                    _this.submitLogin();
                }
            }
        },
        methods: {
			encrypt(str) {
				//console.log(str,"str输出")
				const encryptor = new JSEncrypt()
				encryptor.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCwdgKAqoWf0En2a8VjI+Jcq7JCrGyuPk71h979AkXbp6dEIlNRHvGNbjRjyLvxdXXPjCvX/GCcMzNi+4+u8pfRs0FpxWFf1Rb7q5E1l98Aaam8xz9IHaY7zrtFtUoAzLOlhCr3xduHGQPwbEm/KAup9tv9D1FT1iOx6frQDTnARQIDAQAB') // 设置公钥
				return encryptor.encrypt(str) // 对数据进行加密
			},
			
            // getCaptcha(){
            //     var rdn = Math.random();
            //     this.captchaSrc = this.$client.API_URL+"/adminapi/account/captcha?r=" + rdn;
            // },
            handleSelect(key, keyPath) {

            },
            getStorage(){
                var login = JSON.parse(localStorage.getItem('login'));
                if(login){
                    this.form.username = login.username;
                    this.form.password = login.password;
                    // this.remember = login.is_remember;
                }
            },
            submitLogin(){
                var _this = this;
                if(_this.form.username == ''){
                    _this.$message("请输入账号");
                    return;
                }else if(_this.form.password == ''){
                    _this.$message("请输入密码");
                    return;
                }
                _this.loading = true;
                var has_login = JSON.parse(localStorage.getItem('login'));
                if(has_login){
                    if(this.form.username != has_login.username || this.form.password != has_login.password){
                        localStorage.removeItem('login');
                        //this.form.password = CryptoJS.MD5(this.form.password).toString();
                    }
                }else{
                    //this.form.password = CryptoJS.MD5(this.form.password).toString();
                }
                var params = {
                    // username:encrypt(_this.form.username),
                    // password:_this.form.password,
					loginId:this.encrypt(_this.form.username),
					pwd:this.encrypt(_this.form.password)
                    // captcha:_this.form.captcha
                };
				
                _this.$client.post('/api/sys/user/loginByLoginId', params, function(res,message){
                    _this.loading = false;
					console.log("进入登录环节")
                    _this.$message('登录成功！');
                    // if(_this.remember){
                    //     var login = {username: _this.form.username, password: _this.form.password};
                    //     localStorage.setItem('login', JSON.stringify(login));
                    // }else {
                    //     localStorage.removeItem('login');
                    // }
                    setTimeout(function(){
                        // 跳转到个人中心
                        localStorage.setItem('token',res.token);
                        localStorage.setItem('user_id',res.icode);
                        localStorage.setItem('username',res.userName);
						
						_this.getCurrentMemuList()
                        localStorage.setItem('head_portrait',res.head_portrait);
                        setTimeout(function(){
                            _this.$util.goTo('/index/index')
                        },500);
                    },600);
                }, function(res){
                    //console.log(res)
                    _this.$message(res);
                    _this.loading = false;
                    // if(res===40002){
                        _this.form.password = '';
                    // }
                },true)
            },
			getCurrentMemuList(){
				var _this = this;
				 _this.loading = true;
				console.log( localStorage.getItem('token'),"获取token")
				 var params = {};
				_this.$client.get('/api/sys/menu/getTreeToPCForCurrentUser', params, function(res,message){
					
					var menuList=[]
					var menuItem={}
					var menu_auth_list=[]
					if(res.length >0){
						
						 menuList=[]
						 menu_auth_list=[]
						res.forEach((item)=>{
							console.log(res,"res")
							menuItem={
									id:0,
									name:'',
									icon:'',
									p_id:0,
									url:'',
									power:[],
									sort:0,
									menuKey:'',
									status:0,
									enable:0,
									autoCreateOpen:null,
									children:[],
								}
							console.log(item,"上res进入里面")
							menuItem.id=item.icode,
							menuItem.name=item.name,
							menuItem.icon=item.icon,
							menuItem.p_id=item.parentKey,
							menuItem.url=item.webUrl,
							menuItem.power=item.power,
							menuItem.sort=item.orderIndex,
							menuItem.menuKey=item.menuKey,
							menuItem.status=1,
							menuItem.enable=item.enable,
							menuItem.autoCreateOpen=item.autoCreateOpen
							
							if(item.children.length >0){
								
								item.children.forEach((itemc,indexc)=>{
									var menuItemc={
											id:0,
											name:'',
											icon:'',
											p_id:1,
											url:'',
											power:[],
											sort:0,
											menuKey:'',
											status:0,
											enable:0,
											autoCreateOpen:null,
											children:[],
										}
									menuItemc.id=itemc.icode,
									menuItemc.name=itemc.name,
									menuItemc.icon=itemc.icon,
									menuItemc.p_id=itemc.parentKey,
									menuItemc.url=itemc.webUrl,
									menuItemc.power=itemc.power,
									menuItemc.sort=itemc.orderIndex,
									menuItemc.menuKey=itemc.menuKey,
									menuItemc.enable=itemc.enable,
									menuItemc.autoCreateOpen=itemc.autoCreateOpen,
									menuItemc.status=1
									menuItem.children.push(menuItemc)
									// menu_auth_list.push({
									// 	itemc.parentKey+':'itemc.menuKey+':true'
									// })
								})
							}
							
							menuList.push(menuItem)
							console.log(menuList,"每一个菜单")
							// if(index==0){
								// menuList.push({
								// 	id:2,
								// 	name:'管理',
								// 	icon:'center-icon',
								// 	p_id:0,
								// 	url:'',
								// 	power:[],
								// 	sort:98,
								// 	menuKey:'',
								// 	status:1,
								// 	enable:1,
								// 	autoCreateOpen:null,
								// 	children:[
								// 		{
								// 			id:3,
								// 			name:'菜单管理',
								// 			icon:'icon-order2',
								// 			p_id:1,
								// 			url:'/system/menu',
								// 			power:[],
								// 			sort:33,
								// 			menuKey:'menu',
								// 			status:1,
								// 			enable:1,
								// 			autoCreateOpen:null,
								// 			children:[],
								// 		},
								// 		{
								// 			id:4,
								// 			name:'角色管理',
								// 			icon:'icon-order2',
								// 			p_id:1,
								// 			url:'/system/role',
								// 			power:[],
								// 			sort:33,
								// 			menuKey:'role',
								// 			status:1,
								// 			enable:1,
								// 			autoCreateOpen:null,
								// 			children:[],
								// 		},{
								// 			id:4,
								// 			name:'管理员管理',
								// 			icon:'icon-order2',
								// 			p_id:1,
								// 			url:'/system/admin',
								// 			power:[],
								// 			sort:33,
								// 			menuKey:'admin',
								// 			status:1,
								// 			enable:1,
								// 			autoCreateOpen:null,
								// 			children:[],
								// 		}
								// 	],
									
								// })
							// }
							
							console.log(menuList,"整体菜单")
							
						})
					console.log(menuList,"菜单")
						
					}
					
				    setTimeout(function(){
						console.log(menuList,"菜单")
				         //localStorage.setItem('menu_auth_list',JSON.stringify(res.menu_auth_list?res.menu_auth_list:''));
				        // localStorage.setItem('menu_list',JSON.stringify(res.menu_list?res.menu_list:[]));
						// localStorage.setItem('menu_auth_list',JSON.stringify(''));
						localStorage.setItem('menu_list',JSON.stringify(menuList));
						console.log(localStorage.getItem('menu_auth_list'),"获取菜单")
				    },300);
				}, function(res){
				    _this.$message(res);
				    _this.loading = false;
				   
				        _this.form.password = '';
				   
				},true)
			}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    html,body{
        width: 100%;
        height: 100%;
    }
</style>
<style scoped>
    html,body{
        width: 100%;
        height: 100%;
    }
    .el-header{
        left: 0;
        width: 100%;
        background-color: rgb(28, 41, 50);
    }
    .logo-box{
        float: left;
        width: auto;
    }
</style>